import React from 'react';

import { SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { FormikCheckbox } from '~src/commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { SettingsSection } from '~src/settings/components/common/SettingsSection';

import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';


const EXPLORE_IN_TABLEAU_SITE_ENABLED_FIELD = 'settings.exploreInTableauEnabled';
const EXPLORE_IN_TABLEAU_SITE_SECTION_TEST_ID = 'explore-in-tableau-site-setting-section';
const EXPLORE_IN_TABLEAU_SITE_ENABLED_CHECKBOX_TEST_ID = 'explore-in-tableau-site-enabled';

type SiteExploreInTableauSectionProps = SiteSettingsForSiteAdminProps<'exploreInTableauEnabled'>;

function SiteExploreInTableauSection(props: SiteExploreInTableauSectionProps): React.ReactElement {
    const isOnlineEnvironment: boolean = SessionServerSelectors.isOnlineEnvironment(getAppStore().getState());
    const isInstantAnalyticsEnabled = isOnlineEnvironment ? FeatureFlags.instantAnalyticsSP2 : FeatureFlags.instantAnalyticsOnPremEnabled;
    if (!isInstantAnalyticsEnabled)
      return null;

    return (
      <SettingsSection
        description={Messages.exploreInTableauSiteDescription()}
        title={Messages.exploreInTableauHeader()}
        testId={EXPLORE_IN_TABLEAU_SITE_SECTION_TEST_ID}>
          <FormikCheckbox
            label={Messages.exploreInTableauSiteEnabledLabel()}
            name={EXPLORE_IN_TABLEAU_SITE_ENABLED_FIELD}
            testId={EXPLORE_IN_TABLEAU_SITE_ENABLED_CHECKBOX_TEST_ID}/>
      </SettingsSection>
    );
}

/* for registering the component in settings registry */
export const SiteExploreInTableauSectionSpecs = componentRegistryEntry({
  name: 'SiteExploreInTableauSection',
  component: SiteExploreInTableauSection
});

export { SiteExploreInTableauSection };
